// Browser features tests
export default {
  FileReader: (typeof FileReader !== 'undefined'),
  DragAndDrop: ('draggable' in document.createElement('span')),
  InputFiles: ((() => {
    const input = document.createElement('input');
    input.type = 'file';
    return typeof input.files !== 'undefined';
  })()),
};
